import React from 'react';
import { CloudImage } from '@components/CloudImage';
import ReactHtmlParser from 'react-html-parser';
import { careersPageData } from '@data-ts/pages/careers';
import {
  DisplayAboveMobile,
  DisplayOnMobile,
  WrapperBox,
  StyledBox,
  StyledCloudImage,
  CurlArtBox,
  TextWrapperBox,
  StyledText,
  NameStyledText,
} from './ProductDesigner.styles';

export const ProductDesigner: React.FC = () => {
  const productDesignerData = careersPageData.productDesigner;
  return (
    <WrapperBox>
      <StyledBox backgroundColor="neutra6">
        <DisplayOnMobile>
          <CloudImage src={'careers/mobile/bg-quote3.jpg'} height="100%" width="100%" />
        </DisplayOnMobile>
        <DisplayAboveMobile>
          <CloudImage src={'careers/quotes/3/img-v3.jpg'} height="100%" width="100%" />
          <CurlArtBox>
            <StyledCloudImage src={'careers/quotes/3/curl.svg'} width="100%" />
          </CurlArtBox>
        </DisplayAboveMobile>
        <TextWrapperBox>
          <StyledText color="neutra1" variant="hed40" tagName="h2">
            {ReactHtmlParser(productDesignerData.title)}
          </StyledText>
          <NameStyledText color="neutra1" variant="sectionEyeBrow24" tagName="p" marginTop={6}>
            {productDesignerData.name}
          </NameStyledText>
        </TextWrapperBox>
      </StyledBox>
    </WrapperBox>
  );
};
